import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../../../actions/modalActions';
import theme from '../../../../constants/theme';
import useLockerCode from '../../../../hooks/useLockerCode';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import { ILockerCodes } from '../../../../interfaces/reducers/shipmentsReducer';
import { A } from '../../../base/typography';
import { RawLoader } from '../../../loading/loading';
import * as StyledModals from '../myShipmentsModals.styles';
import { QRCodeCanvas } from 'qrcode.react';

interface Props {}

const QrCode: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const { modalHeading, shipmentId } = useSelector(({ modalReducer }) => modalReducer);

	const width = 250;

	const { lockerCode }: { lockerCode: ILockerCodes } = useLockerCode(shipmentId);


	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{modalHeading}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			{lockerCode[shipmentId]?.loading && <RawLoader />}
			{lockerCode[shipmentId] && !lockerCode[shipmentId]?.loading && !lockerCode[shipmentId]?.error && (
				<StyledModals.CenterWrapper>
					<div>
						<QRCodeCanvas
							value={lockerCode[shipmentId]?.code.qrCodeData}
							fgColor={theme.colors.black}
							size={width}
						/>
						<StyledModals.InfoContainer>
							{lockerCode[shipmentId]?.code.pin.match(/^[0-9]{4} [0-9]{4}$/)
								? t('page-overview.multiPartQRCode')
								: t('page-overview.qrInstruction')}
						</StyledModals.InfoContainer>
						<div>
							{lockerCode[shipmentId]?.code.pin.match(/^[0-9]{4} [0-9]{4}$/) ? (
								<>
									PIN 1:
									<strong>{lockerCode[shipmentId]?.code.pin.substring(0, 4)}</strong>
									<br/>
									PIN 2:
									<strong>{lockerCode[shipmentId]?.code.pin.substring(5)}</strong>
								</>
							) : (
								<>
									PIN:
									<strong>{lockerCode[shipmentId]?.code.pin}</strong>
								</>
							)}
						</div>
					</div>
				</StyledModals.CenterWrapper>
			)}
		</StyledModals.Wrapper>
	);
};

export default QrCode;
